import { useMemo } from 'react';
import { userService } from '../reducers/permissions/userSlice';
import { useTypedSelector } from '../stateStore';
import { AuthHelper } from '../utils/auth/authHelper';

export const useCurrentUserAuth = () => {
  const currentUser = useTypedSelector(userService.selectors.userMe);

  const auth = useMemo(() => {
    if (currentUser) return new AuthHelper(currentUser);
  }, [currentUser]);

  return {
    auth,
    currentUser,
  };
};
